module.exports = __webpack_public_path__ + "img/additional-inter-header.14d7117a.png";